import React from "react"

const ArticleType = ({ post, pageTitle, microDataDescription, favicon }) => {
  const logo = favicon[0].node.childImageSharp.fluid

  return (
    <div type="hidden" style={{ display: "none" }}>
      <div itemScope itemType="http://schema.org/Article">
        <strong>Title:</strong>
        <span itemProp="name">{`${pageTitle}`}</span>
        <br />
        <strong>Headline:</strong>
        <span itemProp="headline">{pageTitle}</span>
        <strong>Author:</strong>{" "}
        <span itemProp="author">{`${post.author.name}`}</span>
        <br />
        <span itemProp="datePublished">{post.date}</span>
        <br />
        <span itemProp="dateModified">{post.date}</span>
        <br />
        <div
          itemProp="publisher"
          itemScope
          itemType="http://schema.org/Organization"
        >
          <span itemProp="name">Dianurse.com - BG</span>
          <span
            itemProp="logo"
            itemScope
            itemType="http://schema.org/ImageObject"
          >
            <link itemProp="url" href={`https:${logo.src}`} />
          </span>
          <link itemProp="url" href="https://bg.dianurse.com/" />
        </div>
        <br />
        <a
          itemProp="mainEntityOfPage"
          href={`https://bg.dianurse.com/${post.slug}`}
        >
          <h1 itemProp="name">{pageTitle}</h1>
        </a>
        <br />
        <strong>Description:</strong>
        <span itemProp="description">{microDataDescription}</span>
        <br />
        <strong>Image:</strong>
        <span itemProp="image">{`https:${post.mainImage.fluid.src}`}</span>
      </div>
    </div>
  )
}

export default ArticleType
